<template>
  <div>
    <v-container
      fluid
      class="fs-admin-container"
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <div style="max-width: 450px">
          <Select
            v-model="receiverType"
            :items="receiverTypes"
            label="Тип получателя"
            item-text="name"
            item-value="id"
            required
          />
          <Select
            v-model="receiveChannel"
            :items="channels"
            :rules="[v => !!v || 'Укажите средство доставки']"
            item-text="name"
            item-value="id"
            label="Средство доставки"
            required
          />
          <Select
            v-if="receiverType !== PARENT"
            v-model="receiverRole"
            :items="roles"
            :blank-value="undefined"
            item-text="name"
            item-value="id"
            label="Роль получателя"
            blank
          />
          <Select
            v-if="receiverType !== ALL"
            v-model="selectedDistrict"
            :items="districts"
            item-text="short_name"
            item-value="id"
            label="Муниципалитет:"
            class="fs-admin-complex-autocomplete"
            blank
          />
          <Select
            v-if="selectedDistrict !== null && receiverType !== ALL"
            v-model="selectedSchool"
            label="Школа:"
            :items="schools"
            item-text="short_name"
            item-value="id"
            blank
          />
          <Select
            v-if="selectedSchool !== null && receiverType === PARENT"
            label="Выберите класс"
            v-model="selectedClass"
            :items="classes"
            item-value="id"
            item-text="name"
            blank
          />
          <Select
            v-if="selectedClass !== null && receiverType === PARENT"
            label="Выберите ученика"
            v-model="selectedStudent"
            :items="students"
            item-value="id"
            item-text="name"
            blank
          />
          <Select
            v-if="selectedStudent !== null && receiverType === PARENT"
            label="Выберите родителя"
            v-model="selectedParent"
            :items="parents"
            item-value="id"
            item-text="name"
            blank
          />
          <v-textarea
            v-model="message"
            :rules="[v => !!v || 'Введите сообщение!']"
            autocomplete="Сообщение..."
            label="Сообщение"
            outlined
          ></v-textarea>
          <v-btn @click="modals.select = true">
            Выбрать из шаблона
          </v-btn>
          <v-btn
            :disabled="!isValid()"
            class="mr-4"
            @click="sendMessage"
          >
            Отправить
          </v-btn>
        </div>
      </v-form>
    </v-container>
    <TemplateMassSelectorModal
      :show.sync="modals.select"
      @select="selectTemplate($event)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Select } from '@/components/common'
import TemplateMassSelectorModal from '@/views/superadmin/notifications/TemplateMassSelectorModal'
import {
  SEND_NOTIFICATION_TO_ALL,
  SEND_NOTIFICATION_TO_UNIT,
  SEND_NOTIFICATION_TO_PARENT,
  GET_SUGGESTION_MUNICIPALITIES,
  GET_SUGGESTION_SCHOOLS,
  GET_SUGGESTION_CLASSES,
  GET_SUGGESTION_USERS
} from '@/requests/superadmin'

const ALL = 1
const SCHOOL = 2
const PARENT = 3

export default {
  name: 'SendNotificationSuperAdmin',
  components: {
    Select,
    TemplateMassSelectorModal
  },
  data() {
    return {
      ALL,
      SCHOOL,
      PARENT,
      districts: [],
      schools: [],
      classes: [],
      students: [],
      parents: [],
      selectedDistrict: null,
      selectedSchool: null,
      selectedClass: null,
      selectedStudent: null,
      selectedParent: null,
      receiverTypes: [
        { name: 'Все', id: ALL },
        { name: 'Школа', id: SCHOOL },
        { name: 'Родитель', id: PARENT }
      ],
      receiverType: ALL,
      receiverRole: undefined,
      receiveChannel: null,
      message: '',
      valid: false,
      modals: {
        select: null
      }
    }
  },
  mounted() {
    this.loadDistricts()
  },
  computed: {
    ...mapState({
      channels: state =>
        state.common.constants.notification_kinds.filter(r =>
          ['SMS', 'EMAIL'].includes(r.alias)
        ),
      roles: state =>
        state.common.constants.role_choices.filter(r =>
          ['TEACHER', 'PARENT'].includes(r.alias)
        ),
      PUPIL_ROLE_DATA: state =>
        state.common.constants.role_choices.find(r => r.alias === 'PUPIL')
    })
  },
  watch: {
    receiverType: function() {
      this.selectedDistrict = null
    },
    selectedDistrict: function(state) {
      this.schools = []
      this.selectedSchool = null

      if (state !== null) {
        this.loadSchools()
      }
    },
    selectedSchool: function(state) {
      this.classes = []
      this.selectedClass = null

      if (state !== null) {
        this.loadClasses()
      }
    },
    selectedClass: function(state) {
      this.students = []
      this.selectedStudent = null

      if (state) {
        this.loadStudents()
      }
    },
    selectedStudent: function(state) {
      this.parents = []
      this.selectedParent = null

      if (state !== null) {
        this.parents = this.students.find(s => s.id === state).parents
      }
    }
  },
  methods: {
    selectTemplate(template) {
      this.message = template.template
    },
    isValid() {
      if (this.receiverType === SCHOOL && !this.selectedSchool) return false
      if (this.receiverType === PARENT && !this.selectedParent) return false
      return this.valid
    },
    async loadDistricts() {
      try {
        let { data } = await GET_SUGGESTION_MUNICIPALITIES()
        this.districts = data.results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить муниципалитеты'
        })
      }
    },
    async loadSchools() {
      try {
        const {
          data: { results }
        } = await GET_SUGGESTION_SCHOOLS({
          district: this.selectedDistrict
        })

        this.schools = results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить школы'
        })
      }
    },
    async loadClasses() {
      try {
        let {
          data: { results }
        } = await GET_SUGGESTION_CLASSES({
          unit: this.selectedSchool
        })

        this.classes = results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию о классах'
        })
      }
    },
    async loadStudents() {
      try {
        let {
          data: { results }
        } = await GET_SUGGESTION_USERS({
          school_class: this.selectedClass,
          unit: this.selectedSchool,
          role: this.PUPIL_ROLE_DATA.id
        })

        this.students = results
      } catch {
        this.$notify({
          type: 'error',
          text: 'Не удалось загрузить информацию об учениках'
        })
      }
    },
    async sendMessage() {
      try {
        const commonData = {
          notification_type: this.receiveChannel,
          message: this.message.trim(),
          notification_role: this.receiverRole
        }

        if (this.receiverType === ALL) {
          await SEND_NOTIFICATION_TO_ALL(commonData)
        } else if (this.receiverType === SCHOOL) {
          await SEND_NOTIFICATION_TO_UNIT({
            ...commonData,
            unit: this.selectedSchool
          })
        } else {
          await SEND_NOTIFICATION_TO_PARENT({
            ...commonData,
            role: undefined,
            user: this.selectedParent
          })
        }

        this.$notify({
          type: 'success',
          text: 'Сообщение успешно отправлено'
        })

        this.receiverType = ALL
        this.receiverRole = undefined
        this.receiveChannel = null
        this.message = ''
        this.resetForm()
      } catch (error) {
        console.log(error)
        this.$notify({
          type: 'error',
          text: 'Не удалось отправить сообщение'
        })
      }
    },
    resetForm() {
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
    }
  }
}
</script>